"use client"
import { EmptyMessage } from "@tapcart/mobile-components"
import { usePathname, useRouter, useSearchParams } from "next/navigation"
import { useActions } from "@tapcart/app-studio-sdk"
import * as Sentry from "@sentry/nextjs"
import { useEffect } from "react"

export default function ErrorComponent({
  error,
  tags,
}: {
  error: Error
  tags?: Record<string, string>
}) {
  useEffect(() => {
    Sentry.captureException(error, {
      tags: {
        context: "client_error_component",
        ...tags,
      },
    })
  }, [error, tags])

  const actions = useActions()

  return (
    <div className="flex h-screen">
      <EmptyMessage
        iconName="mood-sad"
        title="Oh no!"
        description="Something went wrong, please try again."
        openScreen={actions.openScreen}
        usePathname={usePathname}
        useRouter={useRouter}
        useSearchParams={useSearchParams}
        buttonLabel="Keep Shopping"
      />
    </div>
  )
}
